import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';
import { SCREENS } from '~/constants/screens';

const FoodicsLogLink = (): ReactElement => {
  return (
    <Link to={SCREENS.FOODICS_LOG()} className="foodics-log-link color-mainblue text-size-14 family-regular">
      {localeStore.t('foodics_log')}
    </Link>
  );
};

export default FoodicsLogLink;
